export default [
	{
		path: 'scheduledtasks/exports',
		name: 'scheduledtasks-exports',
		meta: {
			pageTitle: 'Scheduled Report Outputs',
			desktopOptimized: true
		},
		props: route => ({
			searchParams: route.query
		}),
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(
				/* webpackChunkName: "scheduleReportManager" */ '@/sections/scheduled-tasks/report-exports/report-exports-outputs/report-exports-outputs-page.vue'
			)
	}
];
